import $ from 'jquery'

class Backlink {
  constructor(selector = '.page-header__backlink') {
    this.el = $(selector)
    this.canActivate = this.isHistoryBackPossible()

    if (!this.el.length || !this.canActivate) {
      return
    }

    this.initListener()
  }

  initListener() {
    this.el.on('click', event => {
      event.preventDefault()
      // event.stopImmediatePropagation()
      window.history.back()
    })
  }

  isHistoryBackPossible() {
    const host = window.location.hostname
    return document.referrer.indexOf(host) > -1
  }
}

export default Backlink
